export default "__VITE_ASSET__7_Xja_cy__"